import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

// Interfaces
import { CardItem } from "Interfaces/Cards"
import { useAuth } from "Context/Auth/useAuth"

// Iconos
import UserAdministration from "assets/images/Administration/user-control.png"
import Cards from "Components/Cards"
import { Slide } from "@mui/material"

const Administration = () => {
    const { t } = useTranslation()
    const auth = useAuth()

    const elementsValidateRender = useCallback((permiss: string[]): CardItem[] => {
        let cards = [
            {
                id: 0,
                title: t('userControl.text_1'),
                path: "usercontrol",
                img: UserAdministration,
                description: "register",
                type: "userAdministration"
            }
        ]
        cards = cards.filter((item: CardItem) => permiss.includes(item.type));
        return cards
    }, [t])

    const cardsInfo: CardItem[] = useMemo(() => {
        if (auth.user?.role === "admin" || auth.user?.role === "adminComercial") {
            return elementsValidateRender([
                "userAdministration"
            ])
        } else if (auth.user?.role === "adminsupport") {
            return elementsValidateRender([
                "userAdministration"
            ])
        }
        return []
    }, [auth.user?.role, elementsValidateRender])

    return( 
        <Slide direction="left" in={true}>
            <div style={{ display: 'block', margin: '20px auto', width: "95%" }}>
                {
                    cardsInfo.length > 0 ?
                        <div className='gridContainerComercial'>
                            { cardsInfo.map((item, index) => <Cards key={index} item={item} site={"comercial"} />) }
                        </div>
                        :
                        <div style={{ textAlign: "center", marginTop: "30%" }}>
                            <p>No tienes permisos para acceder a este modulo</p>
                        </div>
                }
            </div>
        </Slide>
    )
}

export default Administration